import { action } from '@ember/object';

import moment from 'moment';

import type { PopupData, Timeframe } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/common/timeframe/dropdown';
import CommonTimeframeDropdownComponent from 'webapp/components/common/timeframe/dropdown';
import ForecastsTimeframePopupComponent from 'webapp/components/forecasts/timeframe/popup';

import type Forecast from 'webapp/models-custom/forecast';

interface Args extends Omit<BaseArgs, 'onChange'> {
	model: Forecast;
	onChange: (value: Timeframe | null, endDate?: string | null) => void;
}

export default class ForecastsTimeframeDropdownComponent extends CommonTimeframeDropdownComponent<Args> {
	popupComponent = ForecastsTimeframePopupComponent;

	popupExtraClass = '';

	override showIcon = false;

	get isDisabled(): boolean {
		return !!this.args.isDisabled;
	}

	override get optionsForDropdown() {
		const endDate = this.args.model.endDate;

		if (endDate) {
			const baseOptions = super.optionsForDropdown;
			const label = `End of ${moment(endDate, 'YYYY_MM').format('MMMM YYYY')}`;
			return [{ ...baseOptions[0]!, label }];
		}

		return super.optionsForDropdown;
	}

	@action
	override getPopupProps(): PopupData.Forecast.Timeframe {
		const baseProps = super.getPopupProps();
		return {
			...baseProps,
			endDate: this.args.model.endDate,
			onChange: (timeframe: Timeframe | null, endDate?: string | null) => {
				this.args.model.timeframe = timeframe;
				this.args.model.endDate = endDate || null;
				this.args.onChange(timeframe, endDate);
				this.updateDateLabel();
			},
		};
	}
}
